import { render, staticRenderFns } from "./legendBox13.vue?vue&type=template&id=37523613&scoped=true&"
import script from "./legendBox13.vue?vue&type=script&lang=js&"
export * from "./legendBox13.vue?vue&type=script&lang=js&"
import style0 from "./legendBox13.vue?vue&type=style&index=0&id=37523613&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37523613",
  null
  
)

export default component.exports